import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import {
  deleteUserQualification,
  fetchUserBackgroundVerificationDocs,
  fetchUserQualificationsByType,
} from "../../../services/api/user";

import { useMutation, useQuery } from "@tanstack/react-query";
import { deleteDigitalAsset } from "../../../services/api/digitalAsset";
import AddBackgroundVerificationModal from "../../CompleteYourProfile/components/AddBackgroundVerificationModal";
import BaseConfirmModal from "../../../components/ui/BaseConfirmModal";

const AddEditBackgroundVerification = ({ backgroundCheckId, userId }) => {
  const [isAddBackgrounVerificationModalOpen, setIsAddBackgrounVerificationModalOpen] =
    useState(false);
  const [qualificationToDelete, setQualificationToDelete] = useState(null);

  const {
    isPending: isDeleteUserQualificationApiLoading,
    error: isDeleteUserQualificationApiError,
    data: deletedUserQualificationsData,
    mutateAsync: deleteUserQualificationMutation,
  } = useMutation({
    mutationFn: (id) => deleteUserQualification(id, userId),
    enabled: false,
  });

  const {
    data: userQualificationsData,
    isPending: isUserQualificationsApiLoading,
    error: isUserQualificationsApiError,
    refetch: refetchUserQualificationsByType,
  } = useQuery({
    queryKey: ["background check", userId, backgroundCheckId],
    queryFn: () => fetchUserQualificationsByType(userId, backgroundCheckId),
    enabled: !!userId && !!backgroundCheckId,
  });

  const handleBackgroundVerificationDelete = async () => {
    if (!qualificationToDelete) return;
    try {
      await deleteUserQualificationMutation(qualificationToDelete.id);
      await refetchUserQualificationsByType();
      setQualificationToDelete(null);
    } catch (error) {}
  };

  return (
    <div className="mt-6 border-b pb-4">
      <div className="bg-light px-4 py-2 rounded-md flex justify-between items-center ">
        <h6 className="text-dark font-normal">Background Verification</h6>
        <i
          className="fa-solid fa-circle-plus cursor-pointer text-lg text-secondary"
          onClick={() => setIsAddBackgrounVerificationModalOpen(true)}
        ></i>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4 ">
        {userQualificationsData?.data?.map((qualification) => (
          <div className="flex items-center justify-between gap-3 min-w-0 bg-light rounded-md py-3 px-4 cursor-default">
            <div className="flex items-center min-w-0">
              <i className="fa-regular fa-file text-xl text-red-500 shrink-0"></i>
              <p className="ml-3 truncate">{qualification?.qualificationSubType}</p>
            </div>

            <div className="flex items-center shrink-0">
              <a
                href={qualification?.digitalAsset?.url}
                download
                target="_blank"
                type="application/octet-stream"
              >
                <i className="fa-solid fa-download mr-3 text-emerald-700 text-base cursor-pointer"></i>
              </a>

              <i
                className="fa-regular fa-trash-can text-red-600 cursor-pointer"
                onClick={() => setQualificationToDelete(qualification)}
              ></i>
            </div>
          </div>
        ))}
      </div>

      {qualificationToDelete && (
        <BaseConfirmModal
          open={!!qualificationToDelete}
          onClose={() => setQualificationToDelete(null)}
          cancelText="Cancel"
          confirmText="Delete"
          confirmButtonColor="error"
          type="warning"
          title="Delete Background Verification"
          description={`Are you sure you want to delete "${qualificationToDelete?.qualificationSubType}"? This action cannot be undone.`}
          isLoading={isDeleteUserQualificationApiLoading}
          onConfirm={handleBackgroundVerificationDelete}
        />
      )}

      {isAddBackgrounVerificationModalOpen && (
        <AddBackgroundVerificationModal
          refetchUserQualificationsByType={refetchUserQualificationsByType}
          open={isAddBackgrounVerificationModalOpen}
          close={setIsAddBackgrounVerificationModalOpen}
          backgroundCheckId={backgroundCheckId}
          targetUserId={userId}
        />
      )}
    </div>
  );
};

export default AddEditBackgroundVerification;
